import { graphql } from '../graphql';

export const searchProjectsQuery = graphql(`
  query SearchProjects($query: String!) {
    searchProjects(query: $query) {
      id
      name
      description
      organizationId
      organizationName
      organizationSlug
    }
  }
`);
